import { render, staticRenderFns } from "./ppSteps.vue?vue&type=template&id=40ec0e7c&scoped=true&"
import script from "./ppSteps.vue?vue&type=script&lang=js&"
export * from "./ppSteps.vue?vue&type=script&lang=js&"
import style0 from "./ppSteps.vue?vue&type=style&index=0&id=40ec0e7c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ec0e7c",
  null
  
)

export default component.exports